import React, { useEffect, useState } from "react";
import { useApiClient } from "../../../shared/customHooks";
import { useApplicationContext } from "../context/applicationContext";
import { supportingDocumentsForm } from "../../../shared/formObjects/application/supportingDocumentsForm";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";
import { FormikProps } from "formik";
import { useGlobalContext } from "../../../shared/GlobalContext";

function SupportingDocumentsComponent({ disabled, data }: any) {
  const api = useApiClient("SupportingDocuments");
  const [formContext, setFormContext] = useState<any>({});
  const { id, applicationBase } = useApplicationContext();
  const { accountInfo } = useGlobalContext();

  function getInitalValues(initialData: any, formik: FormikProps<any>) {
    let uuId = applicationBase?.supportingDocuments?.fileUuid;
    if (uuId == null) {
      uuId = crypto.randomUUID();
      formik.setFieldValue("fileUuid", uuId);
    }

    setFormContext({
      uuid: uuId,
      applicationBase: applicationBase,
      isManagerRole: accountInfo.isManager,
      isPresub: applicationBase.isPresubmission,
      isAssessorRole: accountInfo.isAssessor,
      isCurrent: applicationBase?.discriminator === "ApplicationBaseCurrent",
      applicationBaseId: applicationBase?.applicationId,
    });
  }

  useEffect(() => {}, []);

  return (
    <BaseApplicationComponent
      formBody={supportingDocumentsForm}
      headerLabel="Supporting Documents"
      editPath="supportingDocuments"
      apiClient={api}
      disabled={disabled}
      data={data}
      formContext={formContext}
      id={id}
      getInitialValues={getInitalValues}
    />
  );
}

export default SupportingDocumentsComponent;
